const visitorIdRegex = /[a-fA-Z0-9]{16}-[a-fA-Z0-9]{16}/;
const aidName = 's_vi';
const customUkAidName = 'sc_vid';
const fidName = 's_fid';
const anonymousUserId = 'AnonymousUser';
const userHashId = 'USER_HASH_ID';
const Window: any = window as any;
type VisitorIdStrategy = () => string;

const getCookieValue = (cookieName: string) => {
  const parts = `; ${document.cookie}`.split(`; ${cookieName}=`);

  return parts.length === 2 ? parts.pop().split(';').shift() : undefined;
};

const getVid: VisitorIdStrategy = () => {
  if (!!Window.s) return Window.s.visitorID;

  return undefined;
};

const getAid: VisitorIdStrategy = () => {
  const aid = getCookieValue(aidName);

  if (!!aid) {
    if (aid.match(visitorIdRegex)) return aid.match(visitorIdRegex)[0];
  }

  return aid;
};

const getCustomUkAid = () => getCookieValue(customUkAidName);

const getFid: VisitorIdStrategy = () => getCookieValue(fidName);


const visitorIdStrategies: Array<VisitorIdStrategy> = [getVid, getCustomUkAid, getAid, getFid];

const getVisitorId = (): string => {
  for (const strategy of visitorIdStrategies) {
    const value = strategy();
    if (!!value) return value;
  }

  return undefined;
};

const getFallbackVisitorId = getFid;

const getUserId= ():string => getCookieValue(anonymousUserId) || getCookieValue(userHashId);

export { getVisitorId, getFallbackVisitorId, getUserId };
